import React, { useState } from 'react';
import './Pimg.css';

const images = [
  { name: 'Dog', src: '/images/c1.jpg' },
  { name: 'Cat', src: '/images/cat.png' },
  { name: 'Bird', src: '/images/bird.png' },
  { name: 'Fish', src: '/images/fish.png' },
  { name: 'Tree', src: '/images/tree.png' },
];

const Pimg = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [guess, setGuess] = useState('');
  const [message, setMessage] = useState('');

  const handleGuessChange = (e) => {
    setGuess(e.target.value);
  };

  const checkGuess = () => {
    if (guess.toLowerCase() === images[currentIndex].name.toLowerCase()) {
      setMessage('Correct!');
    } else {
      setMessage('Try Again!');
    }
  };

  const nextImage = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
    setGuess('');
    setMessage('');
  };

  return (
    <div className="Appimg">
      <h1>Pictionary Game for Kids</h1>
      <div className="image-container">
        <img src={images[currentIndex].src} alt={images[currentIndex].name} />
      </div>
      <input
        type="text"
        value={guess}
        onChange={handleGuessChange}
        placeholder="Type your guess here"
      />
      <button onClick={checkGuess}>Check</button>
      <button onClick={nextImage}>Next Image</button>
      <p>{message}</p>
    </div>
  );
};

export default Pimg;